import React from 'react'
import ProfileEditIcon from 'assets/icons/profile-edit-icon'
import capitalizeString from 'utils/capitalize'

import {
  ProfileIconImage,
  ProfileIconName,
  ProfileIconNameWrapper, ProfileIconRole,
  ProfileIconStatus,
  ProfileIconWrapper
} from '../style'

const firstLetter = 0
const ProfileIcon = ({ user, ...props }) => {

  return (
    <ProfileIconWrapper data-test='profile-icon'>
      <ProfileIconImage {...props}>
        <ProfileIconStatus>
          <ProfileEditIcon />
        </ProfileIconStatus>
        <p style={{fontSize: '18px', marginTop: '30px'}}>
          {user.firstName.charAt(firstLetter).toUpperCase() + user.lastName.charAt(firstLetter).toUpperCase()}
        </p>
      </ProfileIconImage>
      <ProfileIconNameWrapper>
        <ProfileIconName>
          {`${capitalizeString(user.firstName)} ${capitalizeString(user.lastName)}`}
        </ProfileIconName>
        <ProfileIconRole>
          {capitalizeString(user.Role.name)}
        </ProfileIconRole>
      </ProfileIconNameWrapper>
    </ProfileIconWrapper>
  )
}

export default ProfileIcon
